export interface DoujinCategory {
  id: string;
  name: string;
  desc: string;
  count: number;
  image: string;
}

export interface DoujinWork {
  id: string;
  title: string;
  author: string;
  category: string;
  tags: string[];
  pages: number;
  likes: number;
  image: string;
  summary: string;
}

export const heroImage =
  "https://readdy.ai/api/search-image?query=Vibrant%20anime%20doujin%20illustration%20of%20cheerful%20characters%20gathered%20in%20a%20cozy%20creative%20studio%2C%20warm%20coral%20and%20cream%20color%20palette%2C%20soft%20cel-shaded%20anime%20art%20style%2C%20playful%20energetic%20composition%20with%20flying%20papers%20and%20art%20tools%2C%20pastel%20warm%20lighting%2C%20no%20text&width=1600&height=900&seq=hero-doujin-01&orientation=landscape";

export const categories: DoujinCategory[] = [
  {
    id: "comic-book",
    name: "漫画本",
    desc: "完整剧情连载的同人漫画单行本，以原创或衍生故事为主线，篇幅与质量俱佳。",
    count: 328,
    image:
      "https://readdy.ai/api/search-image?query=Anime%20doujin%20comic%20book%20cover%20art%20with%20two%20expressive%20chibi%20characters%2C%20warm%20coral%20background%2C%20soft%20cel-shaded%20anime%20style%2C%20playful%20and%20clean%20composition%2C%20no%20text&width=800&height=600&seq=cat-manga-01&orientation=landscape",
  },
  {
    id: "artbook",
    name: "插画集",
    desc: "收录创作者的日常涂鸦与精修插画，画风精美，是收藏与临摹的绝佳选择。",
    count: 512,
    image:
      "https://readdy.ai/api/search-image?query=Beautiful%20anime%20illustration%20artbook%20collection%20display%2C%20creamy%20warm%20palette%2C%20soft%20cel-shaded%20anime%20style%20portraits%20and%20landscapes%2C%20elegant%20clean%20layout%2C%20no%20text&width=800&height=600&seq=cat-artbook-01&orientation=landscape",
  },
  {
    id: "yonkoma",
    name: "四格漫",
    desc: "经典四格结构，短短四格笑点十足，适合通勤碎片时间轻松一乐。",
    count: 196,
    image:
      "https://readdy.ai/api/search-image?query=Funny%20four-panel%20gag%20comic%20style%20anime%20illustration%2C%20chibi%20characters%20in%20comic%20grid%20panels%2C%20warm%20coral%20and%20cream%20tone%2C%20soft%20cel-shaded%20anime%20art%2C%20playful%2C%20no%20text&width=800&height=600&seq=cat-yonkoma-01&orientation=landscape",
  },
  {
    id: "webtoon",
    name: "条漫",
    desc: "竖屏长条分镜，节奏明快适合手机阅读，剧情推进爽快直接。",
    count: 274,
    image:
      "https://readdy.ai/api/search-image?query=Vertical%20webtoon%20style%20anime%20scene%2C%20tall%20comic%20strips%20with%20colorful%20frames%2C%20warm%20peach%20and%20teal%20palette%2C%20soft%20cel-shaded%20anime%20style%2C%20dynamic%2C%20no%20text&width=800&height=600&seq=cat-webtoon-01&orientation=landscape",
  },
  {
    id: "short",
    name: "短篇集",
    desc: "多则独立短篇合订，题材多样、脑洞清奇，一本满足多种口味。",
    count: 143,
    image:
      "https://readdy.ai/api/search-image?query=Anime%20short%20story%20collection%20illustration%20with%20multiple%20themes%20and%20mini%20scenes%2C%20warm%20cream%20and%20coral%20tone%2C%20soft%20cel-shaded%20anime%20style%2C%20cozy%20composition%2C%20no%20text&width=800&height=600&seq=cat-short-01&orientation=landscape",
  },
  {
    id: "bundle",
    name: "画集打包",
    desc: "多位画师作品合集打包，一次收获海量精美画作，性价比超高。",
    count: 89,
    image:
      "https://readdy.ai/api/search-image?query=Stacked%20artbook%20bundle%20collection%20of%20multiple%20anime%20artbooks%2C%20warm%20coral%20and%20teal%20palette%2C%20soft%20cel-shaded%20anime%20style%2C%20clean%20product%20display%2C%20no%20text&width=800&height=600&seq=cat-bundle-01&orientation=landscape",
  },
];

export const works: DoujinWork[] = [
  {
    id: "w01",
    title: "星落之时",
    author: "汐见遥",
    category: "漫画本",
    tags: ["校园", "治愈", "长篇"],
    pages: 128,
    likes: 2318,
    image:
      "https://readdy.ai/api/search-image?query=Anime%20book%20cover%20illustration%20of%20a%20girl%20gazing%20at%20a%20starry%20night%20sky%2C%20warm%20coral%20and%20teal%20palette%2C%20soft%20cel-shaded%20anime%20style%2C%20emotional%20composition%2C%20no%20text&width=600&height=800&seq=work-01&orientation=portrait",
    summary: "两位少女在废弃天文台相遇，关于梦想、星空与告别的温暖长篇故事。",
  },
  {
    id: "w02",
    title: "桃色糖分",
    author: "奶昔酱",
    category: "插画集",
    tags: ["日常", "甜系", "合集"],
    pages: 64,
    likes: 1866,
    image:
      "https://readdy.ai/api/search-image?query=Sweet%20anime%20illustration%20artbook%20cover%20of%20a%20happy%20girl%20with%20desserts%2C%20warm%20peach%20and%20cream%20palette%2C%20soft%20cel-shaded%20anime%20style%2C%20cute%20and%20clean%2C%20no%20text&width=600&height=800&seq=work-02&orientation=portrait",
    summary: "收录四季日常与甜点主题插画，画风甜腻治愈，适合收藏临摹。",
  },
  {
    id: "w03",
    title: "笨蛋和部长",
    author: "阿蓝",
    category: "四格漫",
    tags: ["搞笑", "社团", "连载"],
    pages: 40,
    likes: 2140,
    image:
      "https://readdy.ai/api/search-image?query=Funny%20chibi%20anime%20comic%20cover%20of%20two%20silly%20club%20members%2C%20warm%20coral%20and%20cream%20palette%2C%20soft%20cel-shaded%20anime%20style%2C%20playful%20and%20comic%2C%20no%20text&width=600&height=800&seq=work-03&orientation=portrait",
    summary: "笨蛋后辈与傲娇部长相爱相杀的四格日常，笑到停不下来。",
  },
  {
    id: "w04",
    title: "海风来信",
    author: "Mori",
    category: "条漫",
    tags: ["恋爱", "海边", "长篇"],
    pages: 96,
    likes: 3021,
    image:
      "https://readdy.ai/api/search-image?query=Anime%20webtoon%20cover%20of%20two%20people%20by%20a%20sunny%20seaside%2C%20warm%20teal%20and%20peach%20palette%2C%20soft%20cel-shaded%20anime%20style%2C%20romantic%20light%2C%20no%20text&width=600&height=800&seq=work-04&orientation=portrait",
    summary: "暑假海边小镇，一封迟到多年的信让两个陌生人慢慢靠近。",
  },
  {
    id: "w05",
    title: "午夜点心铺",
    author: "栗子圆",
    category: "短篇集",
    tags: ["奇幻", "单元剧", "治愈"],
    pages: 72,
    likes: 1588,
    image:
      "https://readdy.ai/api/search-image?query=Cozy%20anime%20illustration%20of%20a%20mysterious%20midnight%20dessert%20shop%20with%20warm%20lights%2C%20coral%20and%20cream%20palette%2C%20soft%20cel-shaded%20anime%20style%2C%20fantasy%20atmosphere%2C%20no%20text&width=600&height=800&seq=work-05&orientation=portrait",
    summary: "只在午夜营业的甜品店，每位客人都有属于自己的奇幻小故事。",
  },
  {
    id: "w06",
    title: "青空之下",
    author: "云深不知",
    category: "画集打包",
    tags: ["风景", "多人", "合集"],
    pages: 200,
    likes: 2490,
    image:
      "https://readdy.ai/api/search-image?query=Anime%20sky%20and%20clouds%20illustration%20bundle%20cover%2C%20soft%20pastel%20teal%20and%20cream%20palette%2C%20cel-shaded%20anime%20style%2C%20open%20sky%20composition%2C%20no%20text&width=600&height=800&seq=work-06&orientation=portrait",
    summary: "十二位画师联手，收录两百张蓝天白云主题的绝美风景插画。",
  },
  {
    id: "w07",
    title: "旧校舍事件簿",
    author: "舟木",
    category: "漫画本",
    tags: ["悬疑", "校园", "长篇"],
    pages: 152,
    likes: 1977,
    image:
      "https://readdy.ai/api/search-image?query=Mysterious%20anime%20comic%20cover%20of%20an%20old%20school%20building%20at%20dusk%2C%20warm%20coral%20and%20teal%20palette%2C%20soft%20cel-shaded%20anime%20style%2C%20moody%20light%2C%20no%20text&width=600&height=800&seq=work-07&orientation=portrait",
    summary: "社团成员深夜探访废弃校舍，一桩旧案逐渐浮出水面。",
  },
  {
    id: "w08",
    title: "猫与竹轮",
    author: "团团",
    category: "四格漫",
    tags: ["萌宠", "搞笑", "日常"],
    pages: 36,
    likes: 1744,
    image:
      "https://readdy.ai/api/search-image?query=Cute%20anime%20chibi%20cat%20comic%20cover%2C%20warm%20cream%20and%20coral%20palette%2C%20soft%20cel-shaded%20anime%20style%2C%20adorable%20and%20playful%2C%20no%20text&width=600&height=800&seq=work-08&orientation=portrait",
    summary: "吃货橘猫与主人的搞笑四格日常，看一次被萌哭一次。",
  },
];

export const stats = [
  { value: "1200+", label: "收录同人作品" },
  { value: "860+", label: "合作创作者" },
  { value: "48万+", label: "累计阅读人次" },
  { value: "6大", label: "作品分类" },
];

export const features = [
  {
    icon: "ri-archive-2-line",
    title: "分类清晰",
    desc: "漫画本、插画集、四格漫、条漫、短篇集、画集打包六大分类，查找一目了然。",
  },
  {
    icon: "ri-smartphone-line",
    title: "多端适配",
    desc: "竖屏条漫与横版漫画均针对手机与电脑优化，随时随地顺畅阅读。",
  },
  {
    icon: "ri-palette-line",
    title: "画质优先",
    desc: "画集打包与插画集坚持高清呈现，还原作者笔触与色彩细节。",
  },
  {
    icon: "ri-heart-3-line",
    title: "尊重创作",
    desc: "坚持内容来源清晰、尊重原创作者，为每一份热爱负责。",
  },
];

export const testimonials = [
  {
    name: "白夜",
    role: "同人收藏爱好者",
    avatar:
      "https://readdy.ai/api/search-image?query=Cute%20anime%20avatar%20of%20a%20girl%20with%20short%20hair%2C%20warm%20coral%20background%2C%20soft%20cel-shaded%20anime%20style%2C%20clean%20and%20cute&width=200&height=200&seq=av-01&orientation=squarish",
    quote: "分类真的太清楚了，想找插画集直接进对应分类，画集打包性价比也高，收藏党狂喜。",
  },
  {
    name: "Mochi",
    role: "条漫追更用户",
    avatar:
      "https://readdy.ai/api/search-image?query=Cute%20anime%20avatar%20of%20a%20boy%20with%20glasses%2C%20warm%20teal%20background%2C%20soft%20cel-shaded%20anime%20style%2C%20clean%20and%20cute&width=200&height=200&seq=av-02&orientation=squarish",
    quote: "手机上看条漫体验特别棒，追更方便，画质也高清，已经安利给好多朋友了。",
  },
  {
    name: "栗子",
    role: "画师",
    avatar:
      "https://readdy.ai/api/search-image?query=Cute%20anime%20avatar%20of%20a%20girl%20with%20twintails%2C%20warm%20pink%20background%2C%20soft%20cel-shaded%20anime%20style%2C%20clean%20and%20cute&width=200&height=200&seq=av-03&orientation=squarish",
    quote: "作为创作者，在这里认识了很多喜欢我作品的读者，互动氛围特别好。",
  },
];

export const faqs = [
  {
    q: "同人动漫支持哪些作品形式？",
    a: "我们支持漫画本、插画集、四格漫、条漫、短篇集以及画集打包六种主要形式，覆盖从完整连载到精修画作的各类同人作品，满足不同阅读偏好。",
  },
  {
    q: "画集打包里的作品质量如何？",
    a: "画集打包通常由多位画师或同一画师的系列作品合订而成，坚持高清呈现，并尽量保留原始色彩与细节，确保阅读和收藏体验。",
  },
  {
    q: "在哪里浏览和查找我喜欢的分类？",
    a: "首页顶部导航和主题分类板块都可以快速进入不同分类。每个分类都配有清晰的作品列表与简介，方便按需筛选。",
  },
  {
    q: "内容来源和原创版权如何处理？",
    a: "我们坚持尊重原创，内容来源清晰标注，积极维护创作者权益。如果您是作者或发现内容有版权问题，欢迎通过联系我们页面向我们反馈。",
  },
  {
    q: "是否有手机版阅读体验？",
    a: "有的。条漫针对竖屏做了优化，漫画与插画集也支持响应式浏览，手机、平板、电脑都能获得顺畅的阅读体验。",
  },
];

export const navLinks = [
  { label: "首屏", href: "#top" },
  { label: "主题分类", href: "#categories" },
  { label: "热门推荐", href: "#works" },
  { label: "阅读体验", href: "#experience" },
  { label: "品牌口碑", href: "#brand" },
  { label: "常见问题", href: "#faq" },
  { label: "联系我们", href: "#contact" },
];